import { FC } from 'react';
import { DataTableWrapMode } from '../DataTable.types';

/**
 * Иконка высоты строк: жирные линии — строки текста, тонкие — границы строк
 * списка.
 *
 * Набор прямоугольников один и тот же во всех режимах, различаются только их
 * позиции и прозрачность (CSS по data-mode). Так React не пересоздаёт узлы при
 * смене режима, и переход между состояниями виден как перестроение линий —
 * отклик на нажатие живёт внутри самой кнопки.
 */
const RowHeightIcon: FC<{ mode: DataTableWrapMode; size?: number }> = ({ mode, size = 18 }) => (
    <svg className="dtb-rh-ic" data-mode={mode} width={size} height={size} viewBox="0 0 24 24" aria-hidden>
        <rect className="dtb-rh-ic__rule dtb-rh-ic__rule--1" x="1" y="0" width="22" height="1" />
        <rect className="dtb-rh-ic__rule dtb-rh-ic__rule--2" x="1" y="0" width="22" height="1" />
        <rect className="dtb-rh-ic__rule dtb-rh-ic__rule--3" x="1" y="0" width="22" height="1" />
        <rect className="dtb-rh-ic__line dtb-rh-ic__line--1" x="3.5" y="0" width="17" height="1.7" rx="0.85" />
        <rect className="dtb-rh-ic__line dtb-rh-ic__line--2" x="3.5" y="0" width="17" height="1.7" rx="0.85" />
        <rect className="dtb-rh-ic__line dtb-rh-ic__line--3" x="3.5" y="0" width="17" height="1.7" rx="0.85" />
        <rect className="dtb-rh-ic__line dtb-rh-ic__line--4" x="3.5" y="0" width="17" height="1.7" rx="0.85" />
        <rect className="dtb-rh-ic__line dtb-rh-ic__line--5" x="3.5" y="0" width="17" height="1.7" rx="0.85" />
    </svg>
);

export default RowHeightIcon;
